import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, ViewChild, ElementRef, forwardRef, inject } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { APP_ICONS } from '../../icons/app-icons';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-metro-form-input',
  standalone: false, // sigue siendo parte de un módulo
  templateUrl: './metro-form-input.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MetroFormInputComponent),
      multi: true,
    },
  ],
})
export class MetroFormInputComponent implements ControlValueAccessor {
  private santizer = inject(DomSanitizer);

  @Input() label?: string;
  @Input() placeholder?: string = '';
  @Input() size: 'sm' | 'md' | 'lg' = 'md';
  @Input() disabled = false;
  @Input() error?: string;
  @Input() helper?: string;
  @Input() type = 'text';
  @Input() id: string | null = null;
  @Input() autocomplete: string = 'on';
  APP_ICONS = APP_ICONS;
  showPassword = false;


  value = '';
  onChange = (value: string) => { };
  onTouched = () => { };

  writeValue(value: string): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onInputChange(value: string) {
    this.value = value;
    this.onChange(value);
  }

  handleInputChange(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    this.onInputChange(inputElement.value);
  }

  togglePassword() {
    this.showPassword = !this.showPassword;
  }

}

